
import Typography from "@mui/material/Typography";

const Header = () => {
  return (
    <Typography
          variant="h3"
          my={4}
          mx={"auto"}
          align="center"
          fontSize={36}
          color={"salmon"}
        >
          TODO APP with TypeScript
        </Typography>
  )
}

export default Header